export const getLastCareProviderId = state => state.careProvider.lastInteractiveId;